import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative h-[560px] w-full overflow-hidden md:h-[680px]">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Moody%20cinematic%20night%20city%20street%20with%20dramatic%20crimson%20and%20amber%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20shadows%2C%20empty%20road%2C%20atmospheric%20editorial%20photography%2C%20high%20contrast%2C%20film%20grain%20and%20bold%20mysterious%20mood&width=1600&height=900&seq=hl51-hero-01&orientation=landscape"
          alt="黑料51首页主视觉，夜色中的资讯聚合格调背景"
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/90" />

      <div className="relative mx-auto flex h-full w-full max-w-[1440px] flex-col justify-end px-4 pb-10 md:px-8 md:pb-16">
        <div className="hl-rise inline-flex w-fit items-center gap-2 rounded-full bg-accent-500 px-3.5 py-1.5">
          <span className="h-1.5 w-1.5 rounded-full bg-foreground-950 hl-pulse" />
          <span className="font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-foreground-950">
            黑料动态 · 黑料线索 实时汇总
          </span>
        </div>

        <h2 className="hl-rise hl-d1 mt-5 max-w-4xl font-heading text-3xl font-black leading-[1.15] text-background-50 md:text-5xl lg:text-6xl">
          旧料翻新，新料追问，
          <br className="hidden md:block" />
          一条线盯到底
        </h2>

        <p className="hl-rise hl-d2 mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
          黑料51把散落各处的黑料动态与黑料线索收在同一条时间线上，旧料新料都能找到。想看后续怎么变，顺着这条线继续盯就好。
        </p>

        <div className="hl-rise hl-d3 mt-8 flex flex-col gap-6 border-t border-background-50/15 pt-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap items-center gap-x-10 gap-y-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex items-baseline gap-1.5">
                <span className="font-label text-3xl font-semibold text-accent-400 md:text-4xl">
                  {stat.value}
                </span>
                <span className="text-xs text-background-200/70">{stat.unit}</span>
                <span className="ml-1 text-xs text-background-200/70">{stat.label}</span>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <a
              href="#focus"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看今日焦点
            </a>
            <a
              href="#thread"
              className="whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              追踪线索线
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}